import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "backdrop", "panel", "qrContainer", "urlInput", "timer", "expiredMessage"
  ]

  connect() {
    this.intervalId = null
    this.remaining = 0
    this.urlValue = ""
    this.redirectTo = ""
  }

  disconnect() {
    this.stopTimer()
  }

  async open(event) {
    this.redirectTo = event?.currentTarget?.dataset?.redirectTo || window.location.pathname
    this.showModal()
    this.hideExpired()
    await this.generateToken()
  }

  async refresh() {
    this.hideExpired()
    await this.generateToken()
  }

  close() {
    this.hideModal()
    this.stopTimer()
  }

  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.isVisible) {
      this.close()
    }
  }

  async copyUrl() {
    if (!this.urlValue) return
    try {
      await navigator.clipboard.writeText(this.urlValue)
      const btn = event.currentTarget
      const originalText = btn.textContent
      btn.textContent = "Скопировано"
      setTimeout(() => { btn.textContent = originalText }, 1500)
    } catch (err) {
      console.error("Clipboard error:", err)
    }
  }

  // ── Private ────────────────────────────────────────────────────────────────

  async generateToken() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const redirectTo = this.redirectTo || window.location.pathname

    try {
      const response = await fetch("/p220/profile/magic_login_token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ redirect_to: redirectTo })
      })

      if (!response.ok) {
        throw new Error("Network response was not ok")
      }

      const data = await response.json()
      this.urlValue = data.url
      this.qrContainerTarget.innerHTML = data.svg
      const svg = this.qrContainerTarget.querySelector('svg')
      if (svg) {
        svg.style.width = '100%'
        svg.style.height = '100%'
      }
      this.urlInputTarget.value = data.url
      this.startTimer(data.expires_in || 120)
    } catch (err) {
      console.error("QR generation error:", err)
      this.qrContainerTarget.innerHTML = `<div class="text-red-300 text-sm text-center">Ошибка генерации QR</div>`
    }
  }

  startTimer(seconds) {
    this.stopTimer()
    this.remaining = seconds
    this.updateTimerDisplay()
    this.intervalId = setInterval(() => {
      this.remaining--
      this.updateTimerDisplay()
      if (this.remaining <= 0) {
        this.stopTimer()
        this.showExpired()
      }
    }, 1000)
  }

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  updateTimerDisplay() {
    const m = Math.floor(this.remaining / 60).toString().padStart(2, "0")
    const s = (this.remaining % 60).toString().padStart(2, "0")
    this.timerTarget.textContent = `${m}:${s}`

    if (this.remaining < 30) {
      this.timerTarget.classList.add("text-red-300")
      this.timerTarget.classList.remove("text-white/80")
    } else {
      this.timerTarget.classList.remove("text-red-300")
      this.timerTarget.classList.add("text-white/80")
    }
  }

  showExpired() {
    this.expiredMessageTarget.classList.remove("hidden")
  }

  hideExpired() {
    this.expiredMessageTarget.classList.add("hidden")
  }

  showModal() {
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.add("opacity-100", "pointer-events-auto")
    this.panelTarget.classList.remove("opacity-0", "scale-95", "pointer-events-none")
    this.panelTarget.classList.add("opacity-100", "scale-100", "pointer-events-auto")
    this.isVisible = true
  }

  hideModal() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.remove("opacity-100", "pointer-events-auto")
    this.panelTarget.classList.add("opacity-0", "scale-95", "pointer-events-none")
    this.panelTarget.classList.remove("opacity-100", "scale-100", "pointer-events-auto")
    this.isVisible = false
  }
}
